import React from "react";

const Footer: React.FC = () => (
  <footer className="border-t border-gray-200 bg-white py-4 text-center text-sm text-muted">
    &copy; {new Date().getFullYear()} Lighthouse
  </footer>
);

export default Footer;
